// App.js — финальная версия с современной нижней панелью
import React, {useEffect} from 'react';
import './App.css';
import {createHashRouter, RouterProvider} from 'react-router-dom';

// Страницы (без старых Navbar и Header!)
import Home from "./pages/home/home";
// import Auth from "./pages/auth/auth";
import Week from "./pages/week/week";
import Month from "./pages/month/month";
import ReservList from "./pages/reserv/ReservList";


// Иконки — современные и красивые
import Auth from "./pages/auth/auth";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute"
import EditReserv from "./components/modal/editReserv/EditReserv";

// Роутер
const router = createHashRouter([
    {
        element: <Layout/>, children: [
            {path: '/', element: <Home/>},
            {path: '/home', element: <Home/>},
            {path: '/auth', element: <Auth/>},
            {path: '/month', element: <ProtectedRoute><Month/></ProtectedRoute>},
            {path: '/week', element: <ProtectedRoute><Week/></ProtectedRoute>},
            {path: '/reserv', element: <ProtectedRoute><ReservList/></ProtectedRoute>},
            {path: '/edit/*', element: <EditReserv/>},
        ]
    },
]);

export default function App() {
    useEffect(() => {
        document.title = "Менеджмент отеля";
    }, []);
    return <RouterProvider router={router}/>;
}
